<Menu [menuItems]="menuItems" (menuItemClicked)="onMenuItemClicked($event)">
  <button type="button" class="loc-pill" data-testid="dropdown-menu-trigger">
    <span class="loc-pill__label">{{ selectedLabel }}</span>
    <svg
      class="loc-pill__chev"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>
</Menu>
